/*
 * Bootstrap JS Compatibility — replaces bootstrap.bundle.min.js
 * Handles: tabs, collapse, dropdowns, modal dismiss, tooltips (no-op)
 * DELETE after all views are migrated to Stimulus controllers.
 */

function initBsCompat() {
  // Tabs
  document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
    if (tab.dataset.bsCompat) return
    tab.dataset.bsCompat = '1'
    tab.addEventListener('click', (e) => {
      e.preventDefault()
      const targetSel = tab.dataset.bsTarget || tab.getAttribute('href')
      if (!targetSel) return

      // Deactivate siblings
      const parent = tab.closest('.nav-tabs, .nav, [role="tablist"]')
      if (parent) {
        parent.querySelectorAll('[data-bs-toggle="tab"]').forEach(t => t.classList.remove('active'))
      }
      tab.classList.add('active')

      // Show target panel, hide siblings
      const panel = document.querySelector(targetSel)
      if (panel) {
        const tabContent = panel.parentElement
        if (tabContent) {
          tabContent.querySelectorAll('.tab-pane').forEach(p => {
            p.classList.remove('active', 'show')
          })
        }
        panel.classList.add('active', 'show')
      }
    })
  })

  // Collapse
  document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(trigger => {
    if (trigger.dataset.bsCompat) return
    trigger.dataset.bsCompat = '1'
    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      const targetSel = trigger.dataset.bsTarget || trigger.getAttribute('href')
      if (!targetSel) return
      const target = document.querySelector(targetSel)
      if (!target) return
      target.classList.toggle('show')
    })
  })

  // Dropdown
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(trigger => {
    if (trigger.dataset.bsCompat) return
    trigger.dataset.bsCompat = '1'
    trigger.addEventListener('click', (e) => {
      e.stopPropagation()
      const menu = trigger.nextElementSibling ||
                   trigger.parentElement.querySelector('.dropdown-menu')
      if (!menu) return
      // Close all other dropdowns
      document.querySelectorAll('.dropdown-menu.show').forEach(m => {
        if (m !== menu) m.classList.remove('show')
      })
      menu.classList.toggle('show')
    })
  })

  // Close dropdowns on outside click
  document.addEventListener('click', () => {
    document.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'))
  })

  // Modal dismiss
  document.querySelectorAll('[data-bs-dismiss="modal"]').forEach(btn => {
    if (btn.dataset.bsCompat) return
    btn.dataset.bsCompat = '1'
    btn.addEventListener('click', () => {
      const modal = btn.closest('.modal, .feature-modal')
      if (modal) {
        modal.classList.remove('active', 'show')
        modal.style.display = 'none'
      }
    })
  })
}

// Strip compat markers before Turbo caches the page so handlers re-bind on restore
document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('[data-bs-compat]').forEach(el => delete el.dataset.bsCompat)
})

// Init on page load and Turbo navigation
document.addEventListener('DOMContentLoaded', initBsCompat)
document.addEventListener('turbo:load', initBsCompat)
document.addEventListener('turbo:frame-load', initBsCompat)
